import {  createSlice } from '@reduxjs/toolkit';
import {OrderGroups, OrderListModel} from '../../fileSend/models/OrderModels'

const initialState:OrderGroups = {
       OrderGroup:[]
}

const orderSlice = createSlice({
    name:'order',
    initialState,
    reducers:{
        setOrders(state,action:{payload:OrderListModel[]}){
            state.OrderGroup = action.payload;
        }
    }
});

export const {
    setOrders, 
} = orderSlice.actions;

export default orderSlice.reducer;